import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type { MapDataPayload } from '@/api/ApiTypes';

type ChangeStatusResponse = {
	status: string;
	errors?: unknown;
};


const mapGetData = (
	handler: (data: MapDataPayload) => void,
	errorHandler: (error: unknown) => void,
): void => {
	axios.get('/map/get_data/').then(extractData(handler)).catch(errorHandler);
};


const baseStationChangeStatus = (
	id: number,
	action: string,
	handler: (data: ChangeStatusResponse) => void,
): void => {
	axios.post('/base_station/change_status/', { id, action }).then(extractData(handler)).catch(logError);
};


const baseStationChangeGroupStatus = (
	ids: number[],
	action: string,
	handler: (data: ChangeStatusResponse) => void,
): void => {
	axios.post('/base_station/change_group_status/', { ids, action }).then(extractData(handler)).catch(logError);
};


export default {
	mapGetData,
	baseStationChangeStatus,
	baseStationChangeGroupStatus,
	logError,
};
